import styled from 'styled-components';
import styles from './toggle.module.scss';

interface ToggleItem {
  key: string;
  label: React.ReactNode;
}
interface ToggleGroupProps {
  items: ToggleItem[];
  selectedItem: string;
  onChange: (key: string) => void;
}

export const ToggleGroup: React.FC<ToggleGroupProps> = props => {
  return (
    <Group className={styles.toggleGroup}>
      {props.items.map(item => (
        <Item
          $isSelected={item.key === props.selectedItem}
          className={styles.toggleItem}
          key={item.key}
          onClick={() => props.onChange(item.key)}
        >
          {item.label}
        </Item>
      ))}
    </Group>
  );
};

const Group = styled.div`
  background: ${props => props.theme.colors.backgroundInactive};
`;

const Item = styled.div<{ $isSelected: boolean }>`
  background: ${props => props.$isSelected && props.theme.colors.brand};
  &:hover {
    background: ${props => props.theme.colors.brand};
  }
`;
